// ============================================================
// HELPER UTILITIES
// ============================================================

export const formatCurrency = (amount, currency = '$') => {
  if (amount === null || amount === undefined) return `${currency}0`;
  return `${currency}${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0';
  const n = Number(num);
  if (n >= 10000000) return (n / 10000000).toFixed(1) + 'Cr';
  if (n >= 100000)   return (n / 100000).toFixed(1) + 'L';
  if (n >= 1000)     return (n / 1000).toFixed(1) + 'K';
  return n.toLocaleString('en-IN');
};

export const formatDate = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
};

export const formatDateTime = (date) => {
  if (!date) return 'N/A';
  return new Date(date).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
};

export const getInitials = (name) => {
  if (!name) return 'N/A';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const truncate = (str, length = 30) => {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
};

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => { clearTimeout(timeout); func(...args); };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const getStatusColor = (status) => {
  const map = {
    active: '#10B981',
    approved: '#10B981',
    delivered: '#10B981',
    resolved: '#10B981',
    inactive: '#6B7280',
    pending: '#F59E0B',
    suspended: '#EF4444',
    rejected: '#EF4444',
    cancelled: '#EF4444',
    open: '#3B82F6',
    confirmed: '#3B82F6',
    preparing: '#8B5CF6',
    out_for_delivery: '#F97316',
    placed: '#06B6D4',
    closed: '#6B7280',
  };
  return map[status?.toLowerCase()] || '#6B7280';
};

export const getStatusBg = (status) => {
  const map = {
    active: '#D1FAE5',
    approved: '#D1FAE5',
    delivered: '#D1FAE5',
    resolved: '#D1FAE5',
    inactive: '#F3F4F6',
    pending: '#FEF3C7',
    suspended: '#FEE2E2',
    rejected: '#FEE2E2',
    cancelled: '#FEE2E2',
    open: '#DBEAFE',
    confirmed: '#DBEAFE',
    preparing: '#EDE9FE',
    out_for_delivery: '#FFEDD5',
    placed: '#CFFAFE',
    closed: '#F3F4F6',
  };
  return map[status?.toLowerCase()] || '#F3F4F6';
};

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const downloadCSV = (data, filename) => {
  if (!data || !data.length) return;
  const keys = Object.keys(data[0]);
  const csv = [keys.join(','), ...data.map(row => keys.map(k => JSON.stringify(row[k] ?? '')).join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = `${filename}.csv`; a.click();
  URL.revokeObjectURL(url);
};
